import axios from "axios";
import { appToast } from "../appToast";
import { cloneDummy, isDummyDataEnabled } from "../dummyData";

export const getAuthToken = () => localStorage.getItem("token");

export const jsonHeaders = ({ bearer = true } = {}) => ({
  "Content-Type": "application/json",
  Authorization: bearer ? `Bearer ${getAuthToken()}` : getAuthToken(),
});

export const hostUrl = (path) => `${process.env.REACT_APP_HOST}${path}`;

export const plServerUrl = (path) =>
  `${process.env.REACT_APP_PL_SERVER_END_POINT}${path}`;

export const request = (config) => axios.request(config);

const hasData = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (value && Array.isArray(value.data)) return value.data.length > 0;
  if (value && typeof value === "object") return Object.keys(value).length > 0;
  return value !== undefined && value !== null && value !== "";
};

export const withDummyFallback = (value, fallback) =>
  isDummyDataEnabled() && !hasData(value) ? cloneDummy(fallback) : value;

export const withResponseDummyFallback = (response, fallback) => {
  if (!isDummyDataEnabled()) return response;
  const payload = response?.data;
  const nestedData = payload?.data;
  const hasPayloadData = Array.isArray(nestedData)
    ? nestedData.length > 0
    : hasData(payload);
  return hasPayloadData ? response : cloneDummy(fallback);
};

export const handleError = (error) => {
  const status = error?.response?.status ?? error?.status;
  if (status === 401) {
    appToast.error(error?.response?.data?.message);
    localStorage.removeItem("token");
    localStorage.removeItem("isLocal");
    window.location.reload();
  }
};

export const isNetworkUnavailableError = (error) =>
  !error?.response &&
  (error?.code === "ERR_NETWORK" ||
    error?.message === "Network Error" ||
    (typeof navigator !== "undefined" && navigator.onLine === false));

export const handleRequestError = (
  error,
  fallback,
  { networkFallback } = {},
) => {
  handleError(error);
  if (isNetworkUnavailableError(error)) {
    return networkFallback === undefined
      ? undefined
      : cloneDummy(networkFallback);
  }
  if (isDummyDataEnabled() && fallback !== undefined) {
    return cloneDummy(fallback);
  }
  appToast.error(
    error?.response?.data?.message || "Request could not be completed",
  );
  return undefined;
};

export { appToast as message };
